export default {
  logged: 'Logged',
  unlogged: 'Unworked',
  faxNotSupported: 'To log fax is not supported.',
} as const;
